export default "__VITE_ASSET__CV46jkHo__"